// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actualPerDiemPage {
  display: flex;
  flex-direction: column;
  padding: 25px;
}

  .actualPerDiemPage__file-upload {
    width: 300px;
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/ArAp/features/PerDiemDigest/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AAKf;;EAHE;IACE,YAAY;EACd","sourcesContent":[".actualPerDiemPage {\n  display: flex;\n  flex-direction: column;\n  padding: 25px;\n\n  &__file-upload {\n    width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
